import { render, staticRenderFns } from "./RegisterCredentialTef.vue?vue&type=template&id=26e882ac"
import script from "./RegisterCredentialTef.vue?vue&type=script&lang=js"
export * from "./RegisterCredentialTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26e882ac')) {
      api.createRecord('26e882ac', component.options)
    } else {
      api.reload('26e882ac', component.options)
    }
    module.hot.accept("./RegisterCredentialTef.vue?vue&type=template&id=26e882ac", function () {
      api.rerender('26e882ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/components/tef/components/RegisterCredentialTef.vue"
export default component.exports